import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Api from "../../../services/api";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import swal from "sweetalert";
// import SelectFaqTypes from '../../../components/s';
import SelectCidades from "../../../components/SelectCidades";

const validationSchema = yup.object().shape({
  cidade_id: yup.string().required("Cidade obrigatório"),
  nome_pt: yup.string().required("Nome da categoria obrigatório"),
  nome_en: yup.string().required("Nome da categoria obrigatório"),
  nome_es: yup.string().required("Nome da categoria obrigatório"),
});

export default function NewCategoria({
  setOpenModalCategoriaNew,
  loadExperiencias,
  loadExperienciasCategorias,
}) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { isSubmitSuccessful, errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = (dataTopic) => {
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    Api.post("/experiencias/categorias/new", dataTopic, axiosConfig)
      .then((response) => {
        if (response.data.status == "success") {
          swal("Sucesso!", response.data.message, "success");
          loadExperienciasCategorias();
          loadExperiencias();
          setOpenModalCategoriaNew(false);
          reset({ name: "", category: "" });
        } else {
          swal("Erro!", response.data.message, "error");
        }
      })
      .catch((err) => {
        swal("Erro!", "ops! ocorreu um erro: " + err, "error");
      });
  };

  return (
    <>
      <h2>Nova Categoria </h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container className="form">
          <Tabs>
            <TabList>
              <Tab>
                <img src={process.env.PUBLIC_URL + "/images/flag-pt.png"} />
              </Tab>
              <Tab>
                <img src={process.env.PUBLIC_URL + "/images/flag-us.png"} />
              </Tab>
              <Tab>
                <img src={process.env.PUBLIC_URL + "/images/flag-es.png"} />
              </Tab>
            </TabList>
            <TabPanel>
              <Grid item lg={12} md={12} sm={12} sx={12} className="field">
                <label>Nome</label>
                <input type="text" {...register("nome_pt")} />
                <span className="error">{errors.nome_pt?.message}</span>
              </Grid>
            </TabPanel>
            <TabPanel>
              <Grid item lg={12} md={12} sm={12} sx={12} className="field">
                <label>Nome</label>
                <input type="text" {...register("nome_en")} />
                <span className="error">{errors.nome_en?.message}</span>
              </Grid>
            </TabPanel>
            <TabPanel>
              <Grid item lg={12} md={12} sm={12} sx={12} className="field">
                <label>Nome</label>
                <input type="text" {...register("nome_es")} />
                <span className="error">{errors.nome_es?.message}</span>
              </Grid>
            </TabPanel>
            <Grid item lg={12} md={6} sm={12} xs={12} className="field">
              <label>Cidade</label>
              <SelectCidades register={register("cidade_id")} />
              <span className="error">{errors.cidade_id?.message}</span>
            </Grid>
          </Tabs>
        </Grid>
        <div className="actions">
          <button type="submit" className="save">
            Salvar
          </button>
          <a
            href="#"
            className="cancel"
            onClick={() => {
              setOpenModalCategoriaNew(false);
            }}
          >
            Cancelar
          </a>
        </div>
      </form>
    </>
  );
}
